import { Icon, Menu, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jan 08 2024
 **/

interface AlarmSettingMenuProps {
	notificationType: WebServices.SpaceChat.List.Data[number]["rooms"][number]["notificationType"];
	onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
	disabledAlarm?: boolean;
}

interface GeneralAlarmSettingMenuProps extends AlarmSettingMenuProps {
	type: "general";
}

interface OtherAlarmSettingMenuProps extends AlarmSettingMenuProps {
	type: "other";
}

type ChatAlarmSettingMenuProps = GeneralAlarmSettingMenuProps | OtherAlarmSettingMenuProps;

function isGeneral(props: ChatAlarmSettingMenuProps): props is GeneralAlarmSettingMenuProps {
	return props.type === "general";
}
export default function ChatAlarmSettingMenu(props: ChatAlarmSettingMenuProps) {
	if (isGeneral(props)) {
		return <GeneralAlarmSettingMenu {...props} />;
	} else {
		return <OtherAlarmSettingMenu {...props} />;
	}
}

function GeneralAlarmSettingMenu({
	notificationType,
	onClick,
	disabledAlarm = false,
	...rest
}: GeneralAlarmSettingMenuProps) {
	return (
		<Menu.Item
			{...rest}
			id="alarm"
			disabled={disabledAlarm}
			onClick={onClick}
			endEnhancer={<Icon name="RightFilledBig16" size={16} />}
			description={
				<Typography typoColor="neutral_60_100" typoSize="Body5" disabled={disabledAlarm}>
					{notificationType === "ONLY_MENTION"
						? _T("@멘션만")
						: notificationType === "ALL"
							? _T("모든 메시지")
							: _T("전체 알림 끄기")}
				</Typography>
			}
		>
			{_T("알림")}
		</Menu.Item>
	);
}

function OtherAlarmSettingMenu({
	onClick,
	notificationType,
	disabledAlarm = false,
	...rest
}: OtherAlarmSettingMenuProps) {
	return (
		<Menu.Item
			{...rest}
			id="alarm"
			onClick={onClick}
			disabled={disabledAlarm}
			endEnhancer={<Icon name="RightFilledBig16" size={16} />}
			description={
				<Typography typoColor="neutral_60_100" typoSize="Body5">
					{notificationType === "ONLY_MENTION"
						? _T("@멘션만")
						: notificationType === "ALL"
							? _T("모든 메시지")
							: _T("꺼짐")}
				</Typography>
			}
		>
			{_T("알림")}
		</Menu.Item>
	);
}
